export const typography = {
  fontFamily: '"Ideal Sans", sans-serif',
  h1: {
    fontSize: 64,
    lineHeight: 1.2,
    fontWeight: 700,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontSize: 40,
    lineHeight: 1.3,
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  h3: {
    fontSize: 32,
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontSize: 24,
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: '-0.01em',
  },
  h5: {
    fontSize: 20,
    lineHeight: 1.4,
    fontWeight: 500,
  },
  h6: {
    fontSize: 16,
    lineHeight: 1.4,
    fontWeight: 500,
  },
  subtitle1: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 500,
    letterSpacing: '0.01em',
  },
  subtitle2: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 500,
    letterSpacing: '0.01em',
  },
  body1: {
    fontSize: 16,
    lineHeight: 1.5,
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 400,
  },
  caption: {
    fontSize: 12,
    lineHeight: 1.5,
    fontWeight: 400,
    letterSpacing: '0.02em',
  },
  overline: {
    fontSize: 12,
    lineHeight: 1.5,
    fontWeight: 600,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  },
  button: {
    textTransform: 'none',
    fontWeight: 500,
    letterSpacing: '0.02em',
  },
} as const
